import { render, staticRenderFns } from "./TechnicianLayout.vue?vue&type=template&id=84b50b92&"
import script from "./TechnicianLayout.vue?vue&type=script&lang=js&"
export * from "./TechnicianLayout.vue?vue&type=script&lang=js&"
import style0 from "./TechnicianLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports